import { generateSchedule } from "../../js/generateSchedule";
import { fromPortal } from "../../js/getHomework";
import Class from "../partials/Class";
import ClassModals from "../partials/ClassModals";
import Day from "../partials/Day";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Settings from "../partials/Settings";
import { getCurrentClass, getCurrentDay, setFakeTimers } from "../../js/getLiveClass";
import CurrentClass from "../partials/CurrentClass";
import { getLunch } from "../../js/getLunch";
import { setGCConfig } from "../../slices/databaseSlice";
import { saveGCConfig, getClubs, watchedTutorial } from "../../js/database";
import HomeworkModal from "../partials/HomeworkModal";
import AssignmentCenter from "../partials/AssignmentCenter";
import Share from "../partials/Share";
import { getMX } from "../../js/getLunch";
import { saveLocalGCConfig, watchedTutorialLocal } from "../../js/localDB";
import { useNavigate } from "react-router-dom";
import AddSchedule from "../partials/AddSchedule";
import Convert from "../partials/Convert";
import HelpModal from "../partials/HelpModal";
import { createClient } from "@supabase/supabase-js";
import { AddClub } from "../partials/Club";
import Joyride from "react-joyride";
import { set } from "firebase/database";
import {Modal} from "bootstrap";
import ClubCenter from "../partials/ClubCenter";
import Alarm from "../partials/Alarm";


function Schedule() {
    const user = useSelector(state => state.user);
    const classes = useSelector(state => state.database);
    const [schedule, setSchedule] = useState(0);
    const [homework, setHomework] = useState(0);
    const [currentClass, setCurrentClass] = useState(0);
    const [nextClass, setNextClass] = useState(0);
    const [currentDay , setCurrentDay] = useState(new Date().getDay()-1);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [dates, setDates] = useState(0);
    const [aCenter, setACenter] = useState(false);
    const [clubCenter, setClubCenter] = useState(false);
    const [joyrideStep, setJoyrideStep] = useState(-1)
    const navigate = useNavigate()

    useEffect(() => {
      const supabase = createClient("https://hgchgftqfrtsdtadzdqw.supabase.co", process.env.REACT_APP_SUPABASE_KEY)

      getClubs().then(clubs => {
   //   var clock = setFakeTimers(new Date("9/1/24 12:42 AM"));
      generateSchedule(classes, clubs).then(
        (s) => {
          
            console.log(s, currentDay);
            setSchedule(s);
            var currentClass = getCurrentClass(s);
            setCurrentClass(currentClass[0]);
            setNextClass(currentClass[1]);
            if (s.length > 5) {
              setCurrentDay(getCurrentDay(new Date(), true))
            }
            if (!currentClass[0] && !currentClass[1]) {
              setCurrentDay((day) => {
                if (day >= 5) return 0;
                else return day+1;
              });
            }
        }
        
    )
  })
    }, [classes]);
    useEffect(() => {
     //   console.log(classes);
        
        
        if (classes.hasOwnProperty("settings") && classes.settings.hasOwnProperty("homework") && classes.settings.homework !== "") {
            fromPortal(classes).then(([homework, dates]) => {
                setHomework(homework);
                setDates(dates);
            }
            )
        } else {
          getLunch().then((lunch) => {
            getMX().then((mx) => {
            setHomework({Lunch: {hw:lunch, block:"MAIN"}, MX: {hw:mx, block:"MAIN"}});
            })
          })
        }

        window.onresize = () => {
          setWindowWidth(window.innerWidth);
        }

        

        if (window.location.search.includes("code=")) {
          fetch("/api/gc/getToken"+window.location.search).then((res) => {res.json().then((data) => {
            if (classes.settings.hasOwnProperty("local")) {
              saveLocalGCConfig(data.refresh_token)
            } else {
            saveGCConfig(user.uid, data.refresh_token).then(() => {
              setGCConfig({refresh_token: data.refresh_token});
            });
          }
            window.location.href = window.location.origin;
          })})


        }

        
    }, []);

    useEffect(() => {
      if ((!classes.settings.tutorial) && joyrideStep === -1) {
        
          if (document.getElementById("welcome")) {
            setJoyrideStep(0)
          new Modal(document.getElementById("welcome")).show()
          }
     //  }
    }}
  )

    const joyrideCallback = (callback) => {
    //  console.log(callback)


      if (callback.action === "next" && callback.type === "step:after") {
        // if (callback.index === 2) {
        //   console.log("clicking")
        //   document.querySelector(".dropdown-btn").classList.add("show")
        // }
        if (joyrideStep < 2 || callback.index > 3) {
        setJoyrideStep(joyrideStep+1)
        }
       
        // setTimeout(() => {
        // document.querySelector(".dropdown-btn").click();
        // document.querySelector(".dropdown-menu").addEventListener("hide.bs.dropdown", (e) => {
        //   e.preventDefault();
        //   console.log("prevented")
        // })
        // }, 1000)
      } else if (callback.action === "back") {
        setJoyrideStep(joyrideStep-1)
      } 
       if (callback.type === "tour:end" && callback.status === "finished") {
        if (classes.settings && classes.settings.hasOwnProperty("local")) {
          watchedTutorialLocal();
          setJoyrideStep(-1)
          window.location.reload();
        } else {
          watchedTutorial(user.uid).then (() => {
            setJoyrideStep(-1)
            window.location.reload();
          }
          )
        }
      }
    
    }

if (schedule === 0) return;
    return (
        <div class="container-fluid bg-dark text-white">
          {joyrideStep > -1 &&
          <Joyride steps={[
            {
              target:".class-card",
              content: "Click on a class to view more information about it.",
            },
            {
              target:".lunch-card",
              content: "Click on a Lunch or MX block to see the upcoming lineup.",
            },
            {
              target: ".dropdown-btn",
              content: "Click here to access more options. Click to continue.",
              hideFooter: true
            },
            {
              target: ".settings-btn",
              content: "Click here to change your settings. Click to continue.",
              hideFooter: true
            },
            {
              target:".settings",
              content: "Here you can customize how your schedule is displayed.",
            },
            {
              target:".homework-link",
              content: "Follow the directions to set up homework.",
            },
            {
              target:".flexes",
              content: "Your classes that use the Flex period have been selected by default. You can customize them here.",
              disableScrolling: true
            },
            {
              target:".club-settings",
              content: "Add or remove clubs from your schedule and register clubs that you lead.",
              disableScrolling: true
            }
          ]
          } continuous={true} callback={joyrideCallback} styles={{options:{
            arrowColor: '#fff',
  backgroundColor: '#212529',
  beaconSize: 36,
  overlayColor: 'rgba(0, 0, 0, 0.5)',
  primaryColor: 'rgb(0, 114, 207)',
  spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
  textColor: '#fff',
  width: undefined,
  zIndex: 100,
            zIndex:1500}}} stepIndex={joyrideStep} spotlightClicks={true} />}
   <nav class="navbar navbar-light">
  <div class="container-fluid text-center">
    <button class="abs-center-x no-click btn btn-dark" style={{fontSize: "25px"}}>WIT&SKILLDULE</button>
<div class="btn-group dropstart ms-auto">
  <button type="button" class="btn btn-dark dropdown-btn" style={{fontSize: "25px"}} onClick={() => {
    if (joyrideStep !== -1) {
    setJoyrideStep(3)
    }
  }} data-bs-toggle="dropdown" aria-expanded="false">
    &#9776;
  </button>
  <ul class="dropdown-menu" style={{backgroundColor: "#0072CF"}}>
    {classes.settings.hasOwnProperty("local") ?
    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#cs">Copy Schedule</button></li>
    :<li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#share">Share</button></li>
    }
    {classes.settings.hasOwnProperty("local") &&
    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#convert">Convert</button></li>}
    {!user.shared &&
    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#setSchedule">Change Schedule</button></li>}
    {!user.shared &&
    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#alarm">Set Alarm</button></li>}
    {(classes.settings.hasOwnProperty("homework") && classes.settings.homework !== "")  &&
        <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#homework">Homework</button></li>}
      <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#Lunch">Lunch</button></li>
      {!user.shared &&
    <li><button class="dropdown-item settings-btn" data-bs-toggle="modal" data-bs-target="#settings" onClick={()=> {if (joyrideStep !== -1) {
      setJoyrideStep(4)
      }}}>Settings</button></li>}
    {/* <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#chat">Discord</button></li> */}
    <li><button class="dropdown-item"><div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onChange={(e) => {
    setACenter(false)
    setClubCenter(e.target.checked)
  }}/>
  <label class="form-check-label" for="flexSwitchCheckDefault">Club Center</label>
</div></button></li>
    {((classes.settings.hasOwnProperty("homework") && classes.settings.homework !== "") || classes.settings.hasOwnProperty("gcconfig")) &&
    <li><button class="dropdown-item"><div class="form-check form-switch">
  <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onChange={(e) => {
    setACenter(e.target.checked)
    setClubCenter(false)
  }}/>
  <label class="form-check-label" for="flexSwitchCheckDefault">Assignment Center</label>
</div></button></li>}
    <li><button class="dropdown-item" data-bs-toggle="modal" data-bs-target="#faq">Help!</button></li>
  </ul>

</div>
{classes.settings.hasOwnProperty("local") &&
<div class="modal fade" id="cs" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{display: "none"}}>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content bg-dark text-center">
            <div class="modal-header mx-auto">
              <h5 class="modal-title" id="exampleModalLongTitle">Scan For Schedule:</h5>
            </div>
            <div class="modal-body">
              <img id="qrcode" src={"https://api.qrserver.com/v1/create-qr-code/?size=300x300&data="+window.location.origin+"/?schedule="+btoa(JSON.stringify(classes))} class="pb-4 mx-auto"/>
              <br/>
              <p>Scan the QR Code with Camera(iOS)/Google Lens(Andrioid)</p>
              <div class="border-top my-3"></div>
              <p>If you can't scan a qr code, send this link to your other device.</p>
              <div class="text-center"><button class="btn btn-primary" onClick={(e) => {
                navigator.clipboard.writeText(window.location.origin+"/?schedule="+btoa(JSON.stringify(classes))).then(function() {
                  e.target.innerText = "Copied!"
                  e.target.classList.remove("btn-primary")
                  e.target.classList.add("btn-success")
                })
              }} id="copyLink">Copy Link</button></div>
<button type="submit" class="btn btn-primary mt-4" data-bs-dismiss="modal">Done</button>
            </div>
          </div>
        </div>
      </div>
}
<div class="modal fade" id="welcome" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true" style={{display: "none"}}>
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content bg-dark text-center">
            <div class="modal-header mx-auto">
              <h5 class="modal-title" id="exampleModalLongTitle">Welcome to Skilldule!</h5>
            </div>
            <div class="modal-body">
              <p>Skildule shows your schedule, lunches, clubs and MXes. If your new to Skilldule follow the tutorial to see how it works.</p>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" onClick={() => {
                if (classes.settings && classes.settings.hasOwnProperty("local")) {
                  watchedTutorialLocal();
                  setJoyrideStep(-1)
                  window.location.reload();
                } else {
                  watchedTutorial(user.uid).then (() => {
                    setJoyrideStep(-1)
                    window.location.reload();
                  }
                  )
                }
              }}>Skip</button>
              <button type="button" class="btn btn-primary" data-bs-dismiss="modal">Start Tutorial</button>
              </div>
          </div>
        </div>
      </div>
  </div>
</nav>
{user.shared && <h5 class="text-center">Viewing {user.name}'s schedule.</h5>}
<div class="row justify-content-center text-center">
  <div className="col-3-sm current-class">
    <h4>Happening Now</h4>
    <CurrentClass block={currentClass} classTime={true} />

      </div>
      </div>



<div class="pt-4 pb-4 row justify-content-center text-center">
<div className="col-3-sm ">
    <h4>Up Next</h4>
    <CurrentClass block={nextClass} classTime={false} />

       
</div>
  </div>
  <div class="border-top my-3"></div>
  {aCenter ?
  <div class="row pt-4 text-center desktop">
      
  <AssignmentCenter dates={dates}/>
</div>
  : clubCenter ?
    <div class="row pt-4 text-center desktop">
      <ClubCenter />
    </div> :
    <div class="row pt-4 text-center desktop">
    {window.innerWidth <1335 ?
          <Day day={schedule[currentDay].schedule} dayName={false ? currentDay === new Date.getDay()? "Today" : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"][currentDay] : currentDay == getCurrentDay()? "Today" : schedule[currentDay].date.toDateString().split(" ").slice(0, -1).join(" ")} dayNumber={schedule[currentDay].day+1} windowWidth={windowWidth} setCurrentDay={setCurrentDay} currentDay={currentDay} weekMode={schedule.length === 5}/>  
          :
    schedule.map((day, i) => (
      <Day day={day.schedule} dayName={((schedule.length > 5 && i == getCurrentDay()) || (schedule.length === 5 && i === new Date().getDay()-1))? "Today" : day.date.toDateString().split(" ").slice(0, -1).join(" ")} dayNumber={day.day+1} windowWidth={windowWidth}/>  
    ))}
    </div>
    }
    <div class="row pt-4 text-center">
      <p class="lead">WIT&SKILLDULE is a division of the <a href="https://media.discordapp.net/attachments/784994278966951936/981220444680118312/binbows.png" target="_blank">JSFFund of America</a></p>
  </div>
  <ClassModals classes={classes} homework={homework}/>
  <Settings />
  <Alarm />
  <AddClub user={user} />
  <HomeworkModal homework={homework} dates={dates}/>
  <Share />
  <AddSchedule user={user} windowWidth={windowWidth}/>
  <Convert />
  <HelpModal/>
  </div>

    )
    ;
}
export default Schedule;